<template>
  <div>
    <backButton />

    <template v-if="user">
      <div
        v-html="
          $t('Are you sure you want to delete user', {
            user: user.FirstName + ' ' + user.LastName,
          })
        "
      ></div>
      <br />

      <cancelConfirmButtons
        @goBack="goBack"
        :confirmFunction="deleteUser"
        :loading="deleting"
        :confirmLabel="$t('Delete')"
      />
    </template>
    <template v-else-if="!$store.getters.error">
      <preloader></preloader>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: "",
      user: null,
      deleting: false,
    };
  },
  created() {
    this.getUser(this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    deleteUser() {
      this.deleting = true;

      this.$request.delete("/user/" + this.$route.params.id, null, (res) => {
        this.deleting = false;

        if (res.success) {
          this.$router.go(-1);
        } else {
          const toaster = {
            message: res.message,
            timeout: false,
            type: "ERROR",
            toastClassName: ["toaster-color-error", "toaster-layout"],
            bodyClassName: ["toaster-text-layout"],
            icon: "mdi-alert-octagon",
          };
          this.$store.dispatch("setToaster", toaster);
        }
      });
    },
    getUser(id) {
      if (id) {
        this.$request.get("/user/" + id, null, (res) => {
          if (res.success) {
            this.user = res.data;
          } else {
            const toaster = {
              message: res.message,
              timeout: false,
              type: "ERROR",
              toastClassName: ["toaster-color-error", "toaster-layout"],
              bodyClassName: ["toaster-text-layout"],
              icon: "mdi-alert-octagon",
            };
            this.$store.dispatch("setToaster", toaster);
          }
        });
      }
    },
  },
};
</script>

<style>
</style>
